/**
 *  ------------------------------------
 *  Imports
 *  ------------------------------------
 */
import { FunctionComponent, useContext } from 'react';

import MaintenanceContext from 'contexts/MaintenanceContext';
import useMaintenanceBypass from 'hooks/useMaintenanceBypass';

import './MaintenanceNotice.scss';

/**
 *  ------------------------------------
 *  MaintenanceNotice Component
 *  ------------------------------------
 */
const MaintenanceNotice: FunctionComponent = () => {

    const maintenanceData: any = useContext(MaintenanceContext);
    const [maintenanceBypass] = useMaintenanceBypass();

    if (!maintenanceData.maintenance || maintenanceBypass) {
        return null;
    }

    return (
        <section className="maintenance">
            <div data-container>
                {maintenanceData.message?.title && <h2>{maintenanceData.message.title}</h2>}

                {maintenanceData.message?.message &&
                    <div dangerouslySetInnerHTML={{__html: maintenanceData.message.message}}></div>
                }
            </div>
        </section>
    )
}

/**
 *  ------------------------------------
 *  Exports
 *  ------------------------------------
 */
export default MaintenanceNotice;
